/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_VEHICLES_DETAILS_REQUEST,
  FETCH_VEHICLES_DETAILS_SUCCESS,
  FETCH_VEHICLES_DETAILS_FAILURE,
  FETCH_DOMAIN_APPROVER_VEHICLES_REQUEST,
  FETCH_DOMAIN_APPROVER_VEHICLES_SUCCESS,
  FETCH_DOMAIN_APPROVER_VEHICLES_FAILURE,
} from "./VehiclesDetailsTypes";

const initialState = {
  loading: false,
  vehicles: [],
  error: "",
  domainApproverVehicles: {
    loading: false,
    data: null,
    error: "",
  },
};

const vehiclesDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VEHICLES_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_VEHICLES_DETAILS_SUCCESS:
      return {
        loading: false,
        vehicles: action.payload,
        error: "",
      };
    case FETCH_VEHICLES_DETAILS_FAILURE:
      return {
        loading: false,
        vehicles: [],
        error: action.payload,
      };
    
    // Domain Approver Vehicles Cases
    case FETCH_DOMAIN_APPROVER_VEHICLES_REQUEST:
      return {
        ...state,
        domainApproverVehicles: {
          ...state.domainApproverVehicles,
          loading: true,
          error: "",
        },
      };
    
    case FETCH_DOMAIN_APPROVER_VEHICLES_SUCCESS:
      return {
        ...state,
        domainApproverVehicles: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    
    case FETCH_DOMAIN_APPROVER_VEHICLES_FAILURE:
      return {
        ...state,
        domainApproverVehicles: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    
    default:
      return state;
  }
};

export default vehiclesDetailsReducer;
